<div
  class="seller-card flex flex-col md:flex-row gap-4 border border-gray20-500 dark:border-white/10 rounded p-4 mb-4 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
>
  <!-- Thumbnail -->
  <div
    class="seller-card__image relative shrink-0 rounded overflow-hidden bg-gray20-500 dark:bg-white/5"
  >
    <Image
      *ngIf="imageUrl"
      [src]="imageUrl"
      [alt]="attrs.name"
      [full]="true"
      class="w-full h-full object-cover"
    ></Image>
    <div
      *ngIf="!imageUrl"
      class="w-full h-full flex items-center justify-center"
    >
      <mat-icon
        svgIcon="mat_solid:directions_car"
        class="text-gray30-500"
      ></mat-icon>
    </div>

    <span
      class="absolute top-2 left-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide shadow"
      [ngClass]="availabilityClasses"
    >
      <ng-container [ngSwitch]="availabilityKey">
        <ng-container *ngSwitchCase="'in_stock'">{{
          "In stock" | transloco
        }}</ng-container>
        <ng-container *ngSwitchCase="'sold'">{{
          "Sold" | transloco
        }}</ng-container>
        <ng-container *ngSwitchCase="'restoration'">{{
          "Restoration" | transloco
        }}</ng-container>
        <ng-container *ngSwitchCase="'reserved'">{{
          "Reserved" | transloco
        }}</ng-container>
      </ng-container>
    </span>
  </div>

  <!-- Body -->
  <div class="grow flex flex-col justify-between min-w-0 gap-2">
    <div class="flex items-start justify-between gap-2">
      <div class="min-w-0">
        <h5
          class="font-mono text-2xl text-black-motorbest-500 truncate"
          [title]="attrs.name"
        >
          {{ attrs.name }}
        </h5>
        <div class="text-sm text-gray-600 dark:text-gray30-500 truncate">
          {{ metaLine }}
        </div>
      </div>

      <div class="flex items-start gap-2 shrink-0">
        <div class="text-right">
          <div
            class="font-semibold text-gray50-500 dark:text-gray20-500 whitespace-nowrap"
          >
            <ng-container *ngIf="priceLabel">{{
              priceLabel | currency: "EUR"
            }}</ng-container>
            <ng-container *ngIf="!priceLabel">{{
              "On request" | transloco
            }}</ng-container>
          </div>
        </div>

        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          [attr.aria-label]="'Actions' | transloco"
        >
          <mat-icon svgIcon="heroicons_outline:dots-vertical"></mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="edit.emit()">
            {{ "Edit" | transloco }}
          </button>
          <button
            mat-menu-item
            *ngIf="canToggleVisibility"
            (click)="toggleVisibility.emit()"
          >
            <ng-container *ngIf="isVisible">{{
              "Deactivate" | transloco
            }}</ng-container>
            <ng-container *ngIf="!isVisible">{{
              "Activate" | transloco
            }}</ng-container>
          </button>
          <button
            mat-menu-item
            *ngIf="isDealerAccount"
            (click)="toggleDealerVisibility.emit()"
          >
            <ng-container *ngIf="onDealerSite">{{
              "Hide from your site" | transloco
            }}</ng-container>
            <ng-container *ngIf="!onDealerSite">{{
              "Show on your site" | transloco
            }}</ng-container>
          </button>
          <button mat-menu-item (click)="delete.emit()">
            {{ "Delete" | transloco }}
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Status pills -->
    <div class="flex flex-wrap items-center gap-2">
      <span
        class="px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide"
        [ngClass]="approvalClasses"
      >
        <ng-container [ngSwitch]="approvalKey">
          <ng-container *ngSwitchCase="'approved'">{{
            "Approved" | transloco
          }}</ng-container>
          <ng-container *ngSwitchCase="'pending'">{{
            "Pending" | transloco
          }}</ng-container>
          <ng-container *ngSwitchCase="'rejected'">{{
            "Rejected" | transloco
          }}</ng-container>
          <ng-container *ngSwitchCase="'draft'">{{
            "Draft" | transloco
          }}</ng-container>
        </ng-container>
      </span>

      <span
        class="px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide"
        [ngClass]="
          isVisible ? 'bg-green-600 text-white' : 'bg-slate-400 text-white'
        "
      >
        <ng-container *ngIf="isVisible">{{
          "Active" | transloco
        }}</ng-container>
        <ng-container *ngIf="!isVisible">{{
          "Inactive" | transloco
        }}</ng-container>
      </span>

      <span
        *ngIf="expiryDays !== null"
        class="px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide flex items-center gap-1"
        [ngClass]="
          isExpired
            ? 'bg-red-motorbest-600 text-white'
            : isNearExpiry
              ? 'bg-amber-500 text-white'
              : 'bg-gray20-500 text-gray50-500'
        "
      >
        <mat-icon
          svgIcon="heroicons_outline:calendar"
          class="icon-size-4"
        ></mat-icon>
        <ng-container *ngIf="isExpired">{{
          "Expired" | transloco
        }}</ng-container>
        <ng-container *ngIf="!isExpired"
          >{{ 'Expires in {{n}} days' | transloco: { n: expiryDays }
          }}</ng-container
        >
      </span>

      <span
        *ngIf="attrs.isClassic"
        class="px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray20-500 text-gray50-500 dark:bg-white/10 dark:text-gray30-500"
      >
        {{ "Classic" | transloco }}
      </span>
      <span
        *ngIf="attrs.isCertified"
        class="px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray20-500 text-gray50-500 dark:bg-white/10 dark:text-gray30-500"
      >
        {{ "Certified" | transloco }}
      </span>
      <span
        *ngIf="attrs.isNacional"
        class="px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray20-500 text-gray50-500 dark:bg-white/10 dark:text-gray30-500"
      >
        {{ "National" | transloco }}
      </span>
    </div>

    <!-- Adaptativo: club (sócio por anúncio) / dealer (canais de publicação) -->
    <div
      *ngIf="isClubAccount || isDealerAccount"
      class="flex flex-wrap items-center gap-2 text-sm text-gray-600 dark:text-gray30-500"
    >
      <span
        *ngIf="isClubAccount && memberLabel"
        class="flex items-center gap-1"
      >
        <mat-icon
          svgIcon="heroicons_outline:user"
          class="icon-size-4"
        ></mat-icon>
        {{ "Member" | transloco }}: {{ memberLabel }}
      </span>

      <ng-container *ngIf="isDealerAccount">
        <span
          class="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs cursor-default"
          [ngClass]="
            onMarketplace
              ? 'bg-green-600/10 text-green-700 dark:bg-green-400/10 dark:text-green-300'
              : 'text-gray30-500 dark:text-white/30'
          "
          [matTooltip]="
            (onMarketplace
              ? 'Visible on the marketplace'
              : 'Not visible on the marketplace'
            ) | transloco
          "
        >
          <mat-icon
            svgIcon="heroicons_outline:globe"
            class="icon-size-4"
          ></mat-icon>
          {{ "Marketplace" | transloco }}
        </span>
        <span
          class="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs cursor-default"
          [ngClass]="
            onDealerSite
              ? 'bg-green-600/10 text-green-700 dark:bg-green-400/10 dark:text-green-300'
              : 'text-gray30-500 dark:text-white/30'
          "
          [matTooltip]="
            (onDealerSite ? 'Visible on your site' : 'Not visible on your site')
              | transloco
          "
        >
          <mat-icon
            svgIcon="heroicons_outline:office-building"
            class="icon-size-4"
          ></mat-icon>
          {{ "On your site" | transloco }}
        </span>
        <span
          *ngIf="isClubAccount"
          class="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs cursor-default"
          [ngClass]="
            onClub
              ? 'bg-green-600/10 text-green-700 dark:bg-green-400/10 dark:text-green-300'
              : 'text-gray30-500 dark:text-white/30'
          "
          [matTooltip]="
            (onClub
              ? 'Visible on the club page'
              : 'Not visible on the club page'
            ) | transloco
          "
        >
          <mat-icon
            svgIcon="heroicons_outline:users"
            class="icon-size-4"
          ></mat-icon>
          {{ "Club" | transloco }}
        </span>
      </ng-container>
    </div>

    <!-- Métricas -->
    <div
      class="flex flex-wrap items-center gap-4 text-sm text-gray-600 dark:text-gray30-500 tabular-nums"
    >
      <span class="flex items-center gap-1">
        <mat-icon
          svgIcon="heroicons_outline:eye"
          class="icon-size-4"
        ></mat-icon>
        {{ attrs.numberViews || 0 }}
      </span>
      <span class="flex items-center gap-1">
        <mat-icon
          svgIcon="heroicons_outline:phone"
          class="icon-size-4"
        ></mat-icon>
        {{ attrs.numberPhone || 0 }}
      </span>
      <span class="flex items-center gap-1">
        <mat-icon
          svgIcon="feather:message-circle"
          class="icon-size-4"
        ></mat-icon>
        {{ attrs.numberMessages || 0 }}
      </span>
      <span class="flex items-center gap-1">
        <mat-icon
          svgIcon="heroicons_outline:cursor-click"
          class="icon-size-4"
        ></mat-icon>
        {{ attrs.numberClicks || 0 }}
      </span>
    </div>
  </div>
</div>
